import Message from './Message.vue';

export default Message;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/purchases/components/message/index.ts